import { createSelector } from '@ngrx/store';
import * as fromFeature from '@app/notifications/store/reducers';
import * as fromNotification from '@app/notifications/store/reducers/notifications.reducers';

export const selectNotificationsState = createSelector(
  fromFeature.selectNotificationFeatureState,
  (state: fromFeature.State) => state.notifications
);

export const getWindowInfo = createSelector(
  selectNotificationsState,
  fromNotification.getWindowInfo
);

export const getContainerInfo = createSelector(
  selectNotificationsState,
  fromNotification.getContainerInfo
);

export const getCountNotifications = createSelector(
  selectNotificationsState,
  fromNotification.getCount
);

export const getNotificationsState = createSelector(
  selectNotificationsState,
  fromNotification.getNotificationState
);
